module.exports = __webpack_public_path__ + "media/svg-new/figure-2b6a122d.svg";